module.exports = __webpack_public_path__ + "static/img/cart1.b03b8436.png";